import { render } from "./WidgetNotice.vue?vue&type=template&id=30708667&scoped=true"
import script from "./WidgetNotice.vue?vue&type=script&lang=js"
export * from "./WidgetNotice.vue?vue&type=script&lang=js"

import "./WidgetNotice.vue?vue&type=style&index=0&id=30708667&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30708667"]])

export default __exports__